<div class="training-item clickable">
  <div class="icon {{file.fileType}}"></div>
  <div class="name text-color-primary">{{file.name}}</div>
</div>